module.exports = "./img/77bb882b3077514daf05bca6b5370af4.jpg";